import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import ImportStep1 from "./ImportStep1";
import ImportStep2 from "./ImportStep2";
import ImportStep3 from "./ImportStep3";
import CommonHeader from "../../../common/CommonHeader";
import ExhibitorDashboardNavbar from "../dashboard/Header";
import Footer from "../../superAdmin/footer/Footer";
import "../../../index.css"; // assuming index.css has the global styles

const ImportExhibitors = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [parsedHeaders, setParsedHeaders] = useState([]);
  const [columnMapping, setColumnMapping] = useState({});
  const [validationResult, setValidationResult] = useState(null);

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <ImportStep1
            uploadedFile={uploadedFile}
            setUploadedFile={setUploadedFile}
            parsedHeaders={parsedHeaders}
            setParsedHeaders={setParsedHeaders}
            columnMapping={columnMapping}
            setColumnMapping={setColumnMapping}
            setValidationResult={setValidationResult}
            onNext={() => setCurrentStep(1)}
          />
        );
      case 1:
        return (
          <ImportStep2
            uploadedFile={uploadedFile}
            columnMapping={columnMapping}
            validationResult={validationResult}
            setValidationResult={setValidationResult}
            onBack={() => setCurrentStep(0)}
            onNext={() => setCurrentStep(2)}
          />
        );
      case 2:
        return (
          <ImportStep3
            uploadedFile={uploadedFile}
            validationResult={validationResult}
            onBack={() => setCurrentStep(1)}
            onSuccess={() => {
              // reset on complete success
              setCurrentStep(0);
              setUploadedFile(null);
              setParsedHeaders([]);
              setColumnMapping({});
              setValidationResult(null);
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <ExhibitorDashboardNavbar />
      <div className="content-body" style={{ minHeight: "80vh", padding: "20px", paddingBottom: "100px" }}>
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="mb-3">Import Exhibitors</h2>
              <div className="d-flex align-items-center mb-4">
                <div className={`step-item ${currentStep >= 0 ? "text-primary fw-bold" : "text-muted"}`}>
                  1. Upload & Map
                </div>
                <div className="mx-3 text-muted">/</div>
                <div className={`step-item ${currentStep >= 1 ? "text-primary fw-bold" : "text-muted"}`}>
                  2. Validation Report
                </div>
                <div className="mx-3 text-muted">/</div>
                <div className={`step-item ${currentStep >= 2 ? "text-primary fw-bold" : "text-muted"}`}>
                  3. Confirm & Import
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {renderStep()}
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default ImportExhibitors;
